export * from 'cf-core/src/images'
export const Hero404 =
  'https://res.cloudinary.com/codefusiontech/image/upload/v1582791158/general/404Hero.png'
export const appStore =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto:best/ebisu/app-store.png'
export const cftitle =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto:best/ebisu/cftitle.png'
export const googlePlay =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto:best/ebisu/google-play.png'
export const user =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto:best/ebisu/user.png'
export const sharedBg =
  'https://res.cloudinary.com/codefusiontech/image/upload/v1582514489/general/marblebgdefault.jpg'
export const orderStatusProgress =
  'https://res.cloudinary.com/codefusiontech/image/upload/v1554602154/general/OrderStatusProgress.png'
export const orderStatusMeter =
  'https://res.cloudinary.com/codefusiontech/image/upload/v1554666730/general/OrderStatusMeter.png'
export const promoHeader =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto/Shaolin/promoHeader.png'
export const restaurant =
  'https://res.cloudinary.com/codefusiontech/image/upload/v1562129124/Shaolin/restaurant.jpg'
export const yelp =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto/Shaolin/yelp.png'
export const facebook =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto/Shaolin/facebook.png'
export const zomato =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto/Shaolin/zomato.png'
export const contactMobilebg =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto:best/v1576892025/halusushi/contactMobilebg.jpg'
export const rewardbg =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto:best/v1576892025/halusushi/rewardbg.jpg'
export const downloadButton =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto:best/v1576892025/halusushi/downloadButton.png'
export const flowerTL =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto:best/v1576892025/halusushi/flowerTL.png'
export const flowerBR =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto:best/v1576892025/halusushi/flowerBR.png'
export const redeemButton =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto:best/v1576892025/halusushi/redeemButton.png'
export const pointsMeter =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto:best/v1576892025/halusushi/pointsMeter.png'
export const rewardArrowLeft =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto:best/v1576892025/halusushi/rewardArrowLeft.png'
export const rewardArrowRight =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto:best/v1576892025/halusushi/rewardArrowRight.png'
export const rewardDefault =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto:best/v1576892025/halusushi/rewardDefault.png'
export const viewMenu =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto:best/v1582589981/Kaido/viewMenu.png'
export const instagram =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto:best/v1585671918/cafesaladedefruits/saladedefruits_instagram.png'
export const cflogo =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto:best/v1590261442/general/cflogo.png'
export const orderDeliveryButton =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto:best/v1588575172/chickochicken/orderDeliveryButton.png'
export const about2 =
  'https://res.cloudinary.com/assetcodefusion/image/upload/f_auto,q_auto:best/v1606088359/sushicalifornia/about2.jpg'
export const about =
  'https://res.cloudinary.com/codefusionorderonline/image/upload/f_auto,q_auto:best/v1608695663/daeji/about.jpg'
export const contactbg =
  'https://res.cloudinary.com/codefusionorderonline/image/upload/f_auto,q_auto:best/v1606452594/daeji/contactbg.jpg'
export const downloadAppButton =
  'https://res.cloudinary.com/codefusionorderonline/image/upload/f_auto,q_auto:best/v1606452594/daeji/downloadAppButton.png'
export const foodGallery =
  'https://res.cloudinary.com/codefusionorderonline/image/upload/f_auto,q_auto:best/v1606452594/daeji/foodGallery.jpg'
export const hero =
  'https://res.cloudinary.com/codefusionorderonline/image/upload/f_auto,q_auto:best/v1606452594/daeji/hero.jpg'
export const heroText =
  'https://res.cloudinary.com/codefusionorderonline/image/upload/f_auto,q_auto:best/v1606452594/daeji/heroText.png'
export const locationMapBroadway =
  'https://res.cloudinary.com/codefusionorderonline/image/upload/f_auto,q_auto:best/v1606452594/daeji/locationMapBroadway.jpg'
export const locationMapCoquitlam =
  'https://res.cloudinary.com/codefusionorderonline/image/upload/f_auto,q_auto:best/v1608008299/daeji/locationMapCoquitlam.jpg'
export const locationMapMetrotown =
  'https://res.cloudinary.com/codefusionorderonline/image/upload/f_auto,q_auto:best/v1606452594/daeji/locationMapMetrotown.jpg'
export const locationMapSurrey =
  'https://res.cloudinary.com/codefusionorderonline/image/upload/f_auto,q_auto:best/v1606452594/daeji/locationMapSurrey.jpg'
export const locationMapNorthRd =
  'https://res.cloudinary.com/codefusionorderonline/image/upload/f_auto,q_auto:best/v1608008299/daeji/locationMapNorthRd.jpg'
export const logo =
  'https://res.cloudinary.com/codefusionorderonline/image/upload/f_auto,q_auto:best/v1606452594/daeji/logo.png'
export const mobileAbout =
  'https://res.cloudinary.com/codefusionorderonline/image/upload/f_auto,q_auto:best/v1608695664/daeji/mobileAbout.jpg'
export const mobileContactbg =
  'https://res.cloudinary.com/codefusionorderonline/image/upload/f_auto,q_auto:best/v1606452594/daeji/mobileContactbg.jpg'
export const mobileGallery =
  'https://res.cloudinary.com/codefusionorderonline/image/upload/f_auto,q_auto:best/v1606452594/daeji/mobileGallery.jpg'
export const mobileHero =
  'https://res.cloudinary.com/codefusionorderonline/image/upload/f_auto,q_auto:best/v1606452594/daeji/mobileHero.jpg'
export const mobileHeroText =
  'https://res.cloudinary.com/codefusionorderonline/image/upload/f_auto,q_auto:best/v1606452594/daeji/mobileHeroText.png'
export const mobileMapBroadway =
  'https://res.cloudinary.com/codefusionorderonline/image/upload/f_auto,q_auto:best/v1606452594/daeji/mobileMapBroadway.jpg'
export const mobileMapCoquitlam =
  'https://res.cloudinary.com/codefusionorderonline/image/upload/f_auto,q_auto:best/v1606452594/daeji/mobileMapCoquitlam.jpg'
export const mobileMapMetrotown =
  'https://res.cloudinary.com/codefusionorderonline/image/upload/f_auto,q_auto:best/v1606452594/daeji/mobileMapMetrotown.jpg'
export const mobileMapNorthRd =
  'https://res.cloudinary.com/codefusionorderonline/image/upload/f_auto,q_auto:best/v1608008299/daeji/mobileMapNorthRd.jpg'
export const mobileMapSurrey =
  'https://res.cloudinary.com/codefusionorderonline/image/upload/f_auto,q_auto:best/v1606452594/daeji/mobileMapSurrey.jpg'
export const mobilePromotion2 =
  'https://res.cloudinary.com/codefusionorderonline/image/upload/f_auto,q_auto:best/v1606452594/daeji/mobilePromotion2.jpg'
export const mobilePromoBroadway =
  'https://res.cloudinary.com/codefusionorderonline/image/upload/f_auto,q_auto:best/v1606452594/daeji/mobilePromoBroadway.jpg'
export const mobilePromoCoquitlam =
  'https://res.cloudinary.com/codefusionorderonline/image/upload/f_auto,q_auto:best/v1606452594/daeji/mobilePromoCoquitlam.jpg'
export const mobilePromoMetrotown =
  'https://res.cloudinary.com/codefusionorderonline/image/upload/f_auto,q_auto:best/v1606452594/daeji/mobilePromoMetrotown.jpg'
export const mobilePromoSurrey =
  'https://res.cloudinary.com/codefusionorderonline/image/upload/f_auto,q_auto:best/v1606452594/daeji/mobilePromoSurrey.jpg'
export const mobilePromoNorthRd =
  'https://res.cloudinary.com/codefusionorderonline/image/upload/f_auto,q_auto:best/v1608006683/daeji/mobilePromoNorthRd.jpg'
export const orderPickupButton =
  'https://res.cloudinary.com/codefusionorderonline/image/upload/f_auto,q_auto:best/v1606452594/daeji/orderPickupButton.png'
export const promotionsBroadway =
  'https://res.cloudinary.com/codefusionorderonline/image/upload/f_auto,q_auto:best/v1606452594/daeji/promotionsBroadway.jpg'
export const promotionsCoquitlam =
  'https://res.cloudinary.com/codefusionorderonline/image/upload/f_auto,q_auto:best/v1606452594/daeji/promotionsCoquitlam.jpg'
export const promotionsMetrotown =
  'https://res.cloudinary.com/codefusionorderonline/image/upload/f_auto,q_auto:best/v1606452594/daeji/promotionsMetrotown.jpg'
export const promotionsSurrey =
  'https://res.cloudinary.com/codefusionorderonline/image/upload/f_auto,q_auto:best/v1606452594/daeji/promotionsSurrey.jpg'
export const promotionsNorthRd =
  'https://res.cloudinary.com/codefusionorderonline/image/upload/f_auto,q_auto:best/v1608006683/daeji/promotionsNorthRd.jpg'
export const promotions2 =
  'https://res.cloudinary.com/codefusionorderonline/image/upload/f_auto,q_auto:best/v1606452594/daeji/promotions2.jpg'
